import { t } from '@lingui/core/macro';
import type { Bookmark, Folder } from '../types/api';

type BookmarkLocationKind = 'home' | 'archive' | 'folder';

interface BookmarkLocation {
  label: string;
  kind: BookmarkLocationKind;
}

/**
 * Location label for a search result, matching the legacy search row:
 * archived articles are Archive, a known folder uses its display title, and
 * everything else (including a deleted folder) is Home.
 */
function bookmarkLocationLabel(
  bookmark: Pick<Bookmark, 'is_archived' | 'folder_id'>,
  folders: Folder[] | undefined,
): BookmarkLocation {
  if (bookmark.is_archived) {
    return { label: t`Archive`, kind: 'archive' };
  }

  const folderId = bookmark.folder_id;
  if (folderId != null && folderId !== '' && folderId !== 0 && folderId !== '0') {
    const folder = folders?.find((item) => String(item.id) === String(folderId));
    if (folder) {
      return { label: folder.displayTitle, kind: 'folder' };
    }
  }

  return { label: t`Home`, kind: 'home' };
}

export { bookmarkLocationLabel };
export type { BookmarkLocation, BookmarkLocationKind };
